import { useState, useEffect } from 'react';
import Header from './components/header';
import Footer from './components/footer';
import { Routes, Route } from 'react-router-dom';
import Landing from './pages/landing';
import About from './pages/about';
import Inprint from './pages/inprint';
import VideoArchive from './pages/videoarchive';
import M365Updates from './pages/m365updates';
import CalendarPage from './pages/calendar';
import BlogList from './pages/bloglist';
import AIBlog from './pages/aiblog';
import Showcase from './pages/showcase';
import ContactMe from './pages/contactme';
import CookieConsent from './components/CookieConsent';
import { CookieConsentPrefs } from './utils/cookieConsent';

declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
    }
}

function loadGoogleAnalytics() {
    const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (!gaId || document.getElementById('ga-script')) return;
    const s = document.createElement('script');
    s.id = 'ga-script';
    s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    s.async = true;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function (...args: any[]) { window.dataLayer.push(args); };
    window.gtag('js', new Date());
    window.gtag('config', gaId);
}

function loadRecaptcha() {
    const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    if (!siteKey || document.getElementById('recaptcha-script')) return;
    const s = document.createElement('script');
    s.id = 'recaptcha-script';
    s.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    s.async = true;
    document.head.appendChild(s);
}

function loadCalendly() {
    if (document.getElementById('calendly-script')) return;
    const link = document.createElement('link');
    link.id = 'calendly-css';
    link.rel = 'stylesheet';
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    document.head.appendChild(link);
    const s = document.createElement('script');
    s.id = 'calendly-script';
    s.src = 'https://assets.calendly.com/assets/external/widget.js';
    s.async = true;
    document.head.appendChild(s);
}

function App() {
    const [consent, setConsent] = useState<CookieConsentPrefs | null>(null);

    useEffect(() => {
        if (!consent) return;
        if (consent.analytics) loadGoogleAnalytics();
        if (consent.recaptcha) loadRecaptcha();
        if (consent.calendly) loadCalendly();
    }, [consent]);

    return (
        <div className="App">
            <CookieConsent onConsentChange={setConsent} />
            <Header />
            <main className="main">
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/inprint" element={<Inprint />} />
                    <Route path="/videoarchive" element={<VideoArchive />} />
                    <Route path="/m365updates" element={<M365Updates />} />
                    <Route path="/calendar" element={<CalendarPage />} />
                    <Route path="/blogs" element={<BlogList />} />
                    <Route path="/aiblog" element={<AIBlog />} />
                    <Route path="/showcase" element={<Showcase />} />
                    <Route path="/contact" element={<ContactMe />} />
                </Routes>
            </main>
            <Footer />
        </div>
    );
}

export default App;
